import { render, staticRenderFns } from "./SelectToken.vue?vue&type=template&id=131339ea&scoped=true&"
import script from "./SelectToken.vue?vue&type=script&lang=js&"
export * from "./SelectToken.vue?vue&type=script&lang=js&"
import style0 from "./SelectToken.vue?vue&type=style&index=0&id=131339ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131339ea",
  null
  
)

export default component.exports